export type PreviewPage = {
  src: string;
  alt: string;
};

export const previewPages: PreviewPage[] = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/5dtfF5BQrWyULd9UZGRvf4/PAGINA_8.png',
    alt: 'Sample page The Climate System Has Five Connected Parts, showing the atmosphere, hydrosphere, cryosphere, lithosphere and biosphere',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9mcxN4YfLB2BC8LpPohe5L/PAGINA_17.png',
    alt: 'Sample page The Same Sunbeam Spreads Wider Near the Poles, explaining angle of incidence and uneven heating',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/4B3AtZogjJ4M46n2sK9soM/PAGINA_24.png',
    alt: 'Sample page When Energy In Equals Energy Out, Temperature Stays Steady, using a bathtub analogy for energy balance',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/jt4q5FTr6NML3tw9xPx7So/PAGINA_27.png',
    alt: 'Sample page Six Groups of Gases Control the Greenhouse Effect, introducing the main greenhouse gases',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/mArUZ2iLY7TBzSuYfgXXkY/PAGINA_50.png',
    alt: "Sample page Earth's Energy Balance Field Card, a one-page summary of weather and climate, the air, layers, energy path and greenhouse effect",
  },
];
